import React, { createContext, useContext, useEffect, useState } from "react";
import "./FlashLightProvider.css";

const FlashlightContext = createContext({
  position: { x: 0, y: 0 },
  radius: 150,
});

export const useFlashlight = () => useContext(FlashlightContext);

export default function FlashlightProvider({ children, radius = 150 }) {
  const [position, setPosition] = useState({ x: window.innerWidth / 2, y: window.innerHeight / 2 });

  useEffect(() => {
    const handleMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("mousemove", handleMove);
    return () => window.removeEventListener("mousemove", handleMove);
  }, []);

  const value = { position, radius };

  return (
    <FlashlightContext.Provider value={value}>
      <div className="flashlight-provider">{children}</div>
    </FlashlightContext.Provider>
  );
}
 